<script>
import { defineAsyncComponent } from "vue";
import { cn } from "~/utils/cn";

// Stroke width is 40 / rendered pixel size, so the drawn line stays ~1.67px at
// every size. A fixed stroke width makes the same icon read visibly thinner at
// size-4 than at size-5, which is the whole reason this scale exists.
const sizes = {
  xs: { class: "size-3", strokeWidth: 3.33 },
  sm: { class: "size-4", strokeWidth: 2.5 },
  md: { class: "size-5", strokeWidth: 2 },
  lg: { class: "size-6", strokeWidth: 1.67 },
  xl: { class: "size-8", strokeWidth: 1.25 },
};

export default {
  inheritAttrs: false,

  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: String,
      default: "md",
      validator(value) {
        return Object.keys(sizes).includes(value);
      },
    },

    fill: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dynamicComponent() {
      const { name } = this;

      return defineAsyncComponent(() => import(`../../icons/${name}.vue`));
    },

    strokeWidth() {
      return sizes[this.size].strokeWidth;
    },

    iconClass() {
      return cn("svg-icon", sizes[this.size].class, this.fill && "svg-fill", this.$attrs.class);
    },

    inheritedAttrs() {
      const { class: _, ...rest } = this.$attrs;

      return rest;
    },
  },
};
</script>

<template>
  <component :is="dynamicComponent" v-bind="inheritedAttrs" :strokeWidth="strokeWidth" :class="iconClass" />
</template>
